var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    { tag: "component", class: _vm.$style.list },
    [
      _vm.$slots.first ? _c("li", [_vm._t("first")], 2) : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.list, function (value, index) {
        return _c(
          "li",
          {
            key: _vm.keyName
              ? typeof _vm.keyName === "function"
                ? _vm.keyName(value)
                : value[_vm.keyName]
              : index,
          },
          [
            _vm._t("default", null, {
              index: index,
              item: value,
              list: _vm.list,
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.$slots.last ? _c("li", [_vm._t("last")], 2) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }